'use strict'

let definition=require('../../definition/labels/norwegian.js').norwegian;

export let norwegian={
  initiative: {
    title: "Egenskaper",
    fields: {
      name: {
        title: "Navn",
        description: "Beskrivende navn",
      },
      identifier: {
        title: "Identifikator",
        description: "Nummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje initiativet skal styres i"
      },
      asProject: "Definer nytt prosjekt",
      projectCharacteristics: [
        "Drevet av leveranser",
        "Midlertidig - definert start og slutt",
        "Avgrenset og angitte leveranser",
        "Levering av et produkt",
        "Gevinster oppstår vanligvis etter at prosjektet avsluttes",
        "Kortere tidshorisont"],
      asProgramme: "Definer nytt program",
      programmeCharacteristics: [
        "Drevet av en vision on sluttilstanden",
        "Ingen forhåndsdefinert sti",
        "Endringer i forretningsevne",
        "Koordinerte leveranser - inkluderer prosjekter som ikke gir direkte gevinster",
        "Gevinster realiseres underveis og etter programmet",
        "Lenger tidshorisont"
      ],
      asProduct: "Definer nytt produkt",
      productCharacteristics: [
        "Følge opp produktet gjennom hele livsløpet",
        "Drevet av produktstrategi",
        "Organisere oppdateringer (release) i langtidsplan (roadmap)",
        "Tidshorisonten er produktets levetid"
      ]    }
  },
  programme: {
    noProgramme: "Nei - Ikke del av et program",
    yesProgrammePrefix: "Ja - ",
    properties: {
      title: "Programegenskaper"
    },
    title:"Bakgrunn",
    fields: {
      name: {
        title: "Programnavn",
        description: "Beskrivende navn",
      },
      identifier: {
        title: "Programidentifikator",
        description: "Programnummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje programmet skal styres i"
      },
      location: {
        title: "Sted",
        help: "Angi stedet programmet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier programmet"
      },
      background: {
        title: "Begrunnelse og sammenheng",
        description:"Beskriv den nåværende situasjonen, den planlagte forbedringen og hvordan den passer til organisasjonens overordende oppdrag og mål",
        help:`Hva er den nåværende situasjonen?
          Hva er den tiltenkte forbedringen dette programmet vil levere?
          Hvilke organisasjoner er involvert, og hvordan skal organisasjonene forbedres?
          Hvordan passer dette programmet inn i organisasjonens oppdrag og mål?`
      },
      timing: {
        title:"Hvorfor nå?",
        description:"Begrunnelse for tidspunktet",
        help:`Hva er som utløser at vi vil gjøre dette akkurat nå?
          Eventuelle eksterne omstendigheter eller interne faktorer? En ny innsikt, ny teknologi eller en ny strategi som påvirker tidspunktet for denne muligheten?`
      },
      successFactors: {
        title: "Suksessfaktorer",
        description:"Beskriv hvordan suksess som ser ut, hva er kriteriene og hvilke grenser og begrensninger som finnes",
        help:`Hva er de kritiske suksessfaktorene som programmet vil bli vurdert mot?
          Hvilke forventninger finnes til tidsperspektiv, kostnader, gevinster eller potensielle begrensninger?`
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett program",
      update: "Oppdater",
      background: "bakgrunn",
      project: "program"
    }
  },
  product: {
    properties: {
      title: "Produktegenskaper"
    },
    title: "Definisjon",
    fields: {
      name: {
        title: "Produktnavn",
        description: "Beskrivende navn på produktet",
      },
      identifier: {
        title: "Produktidentifikator",
        description: "Produktnummer, identifikator eller kortnavn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg porteføljen produktet skal følges opp i"
      },
      currency: {
        title: "Valuta"
      },
      location: {
        title: "Sted",
        help: "Angi stedet productet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier productet"
      },
      description: {
        title:"Beskrivelse",
        description:"Beskriv hva slags produkt dette er, hva produktet gjør for brukerne, hvilke problemer det løser, hvilke prosesser det støttes og hvordan det er strukturert.",
        help:`Hvilken type produkt er dette? Er det et kategorinavn? Hvem bruker dette produktet og hva skal det gjøre for dem? Hvilke behov møter det eller hvilke problemer løser det? Hvilke prosessområder dekker det? Hva er sammensetningen av produktet? Er det en del av et større system, produktlinje eller plattform? Hvilken del av organisasjonen utvikler eller opprettholder det?`
      },
      background: {
        title: "Bakgrunn",
        description:"Beskriv produktets historie og hvorfor ble det introdusert.",
        help:`Hva utløste opprinnelig produksjonen av dette produktet? Hvorfor var dette produktet foretrukket, og ikke et alternativ eller en eksisterende løsning?`
      },
      vision: {
        title: "Visjon",
        description:"Oppsummer en visjonen eller beskrivelse av produktets sluttmål.",
        help:`Hva er sluttmål for investeringen i dette produktet - for deg, brukeren eller kunden? Hva vil langtidsplanen til slutt føre til? Hva setter den strategiske retningen for utviklingen?`
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett produkt",
      update: "Oppdater",
      project: "produkt",
      background: "definisjon"
    }
  },
  release: {
    noProgramme: "Nei - Ikke del av et program",
    yesProgrammePrefix: "Ja - ",
    properties: {
      title: "Egenskaper for oppdatering"
    },
    fields: {
      name: {
        title: "Navn på oppdateringen",
        description: "Beskrivende navn for oppdateringen",
        help: "Navnet vedlikeholdes i planen for oppdateringen"
      },
      identifier: {
        title: "Identifikator",
        description: "Oppdateringsnummer, identifikator eller kortnavn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg porteføljen produktet skal følges opp i"
      },
      programme: {
        title: "Er oppdateringen del av et program?",
        help: "Velg programmet oppdateringen er en del av (hvis noe)"
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett oppdatering",
      update: "Oppdater",
      project: "oppdatering"
    }
  },
  properties: {
    title: "Prosjektegenskaper",
    fields: {
      name: {
        title: "Prosjektnavn",
        description: "Beskrivende navn",
      },
      identifier: {
        title: "Projektidentifikator",
        description: "Prosjektnummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje prosjektet skal styres i"
      },
      location: {
        title: "Sted",
        help: "Angi stedet prosjektet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier prosjektet"
      },
      projectType: {
        title: "Prosjekttype",
        help: "Forskjellige prosjekt-typer kan ha forskjellige design metoder eller livssyklus-faser "
      },
      category: {
        title: "Kategori",
        help: "Angi størrelsen på prosjektet"
      },
      currency: {
        title: "Valuta"
      },
      programme: {
        title: "Er prosjektet del av et program?",
        help: "Velg programmet prosjektet er en del av (hvis noe)"
      }
    }
  },
  background: definition.background,
  actions: {
    cancel: "Avbryt",
    createProject: "Opprett prosjekt",
    update: "Oppdater",
    background: "bakgrunn",
    project: "prosjekt"
  },
  clone: {
    title: "Klone prosjekt"
  }
};



// WEBPACK FOOTER //
// ./views/add/labels/norwegian.js